import styled from '@emotion/styled';
import {Checkbox} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const CheckboxStyled = styled(Checkbox)`
    padding-bottom: 1rem;
`;
